export default class MatrixFund {
    static Inverse_matrix(content) {
        return fetch(`https://easy-algebra-backend.onrender.com/Inverse_matrix`, {
                'method': 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(content)
            })
            .then(response => response.json())
            .catch(error => console.log(error))
    }
    static Transpose(content) {
        return fetch(`https://easy-algebra-backend.onrender.com/Transpose`, {
                'method': 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(content)
            })
            .then(response => response.json())
            .catch(error => console.log(error))
    }
    static Trace(content) {
        return fetch(`https://easy-algebra-backend.onrender.com/Trace`, {
                'method': 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(content)
            })
            .then(response => response.json())
            .catch(error => console.log(error))
    }
    static Determinant(content) {
        return fetch(`https://easy-algebra-backend.onrender.com/Determinant`, {
                'method': 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(content)
            })
            .then(response => response.json())
            .catch(error => console.log(error))
    }
    static Angle(content) {
        return fetch(`https://easy-algebra-backend.onrender.com/Angle`, {
                'method': 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(content)
            })
            .then(response => response.json())
            .catch(error => console.log(error))
    }
    static Projection(content) {
        return fetch(`https://easy-algebra-backend.onrender.com/Projection`, {
                'method': 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(content)
            })
            .then(response => response.json())
            .catch(error => console.log(error))
    }
    static Affine_Projection(content) {
        return fetch(`https://easy-algebra-backend.onrender.com/Affine_Projection`, {
                'method': 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(content)
            })
            .then(response => response.json())
            .catch(error => console.log(error))
    }


}